import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Uma solução de IA Generativa que permite ao cliente um ganho maior de qualidade, eficiência e produtividade nas entregas de nossas ofertas",
    correct: true,
  },
  {
    option: "b) Um solução de redução de custos para nossos clientes",
    correct: false,
  },
  {
    option: "c) Uma solução que substitui o capital intelectual de desenvolvedores e testers por atividades automatizadas",
    correct: false,
  },
  {
    option: "d) Uma ferramenta que permite o monitoramento constante do andamento dos projetos",
    correct: false,
  },
  {
    option: "e) Um software que auxilia na criação de designs para aplicativos e websites",
    correct: false,
  },
];

export default function Question4(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question4: {
          title: "Qual o principal benefício que o uso do Agiliza Ai para os clientes de aplicações?",
          option: option.option,
          correct: option.correct,
          order: 4
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t("Qual o principal benefício que o uso do Agiliza Ai para os clientes de aplicações?")}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
